import { render, staticRenderFns } from "./TeacherVerify1.vue?vue&type=template&id=5d66a427&"
import script from "./TeacherVerify1.vue?vue&type=script&lang=js&"
export * from "./TeacherVerify1.vue?vue&type=script&lang=js&"
import style0 from "./TeacherVerify1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports